// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"352":"ad40cf61","3755":"c29faa44"}[chunkId] + ".chunk.css");